import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-action-types';

import type {Map} from 'immutable';

export type ReservationStore = {
    reservation: Map<unknown, unknown>;
};

const initialState = () => {
    return {
        reservation: Immutable.Map(),
    };
};

const actionsMap = {
    [actionTypes.GET_RESERVATION_SUCCESS]: (state, action) => {
        return {
            reservation: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationStore>(initialState(), actionsMap);
